import styled from "styled-components";

export const filter = styled.div`
    color: #F58B1E;
    border: 2px solid #F58B1E;
    font-size: 1.3rem;
    width: 8rem;
    text-align: center;
    padding: .3rem 1rem;
    border-radius: 5px;
    margin-left: 1.5rem;
    cursor: pointer;


    @media (max-width: 999px){
        font-size: 1.2rem;
        width: 7.5rem;
        margin-left: 1.3rem;
    }
`